<nb-card class="card-scroll">
	<nb-card-header class="card-header-title">
		<div class="card-header-title">
			<h4><ngx-header-title [allowEmployee]="false"> {{ 'GOALS_PAGE.GOAL_SETTINGS' | translate }} </ngx-header-title></h4>
		</div>
		<div>
			<ga-layout-selector
				*ngIf="selectedTab != 'general'"
				[componentName]="viewComponentName"
			></ga-layout-selector>
		</div>
	</nb-card-header>
	<nb-card-body>
		<nb-tabset (changeTab)="tabChange($event)">
			<nb-tab
				tabId="general"
				tabTitle="{{ 'GOALS_PAGE.SETTINGS.GENERAL' | translate }}"
			>
				<div>
					<nb-card>
						<nb-card-body>
							<form
								[formGroup]="generalSettingsForm"
								(change)="saveGeneralSettings()"
							>
								<div class="row">
									<div class="col-md-4">
										<p class="font-weight-bold">
											{{
												'GOALS_PAGE.SETTINGS.MAX_ENTITIES'
													| translate
											}}
										</p>
										<div class="row">
											<div class="col-md-4">
												<label
													class="label"
													for="max-goals"
												>
													{{
														'GOALS_PAGE.FORM.LABELS.OBJECTIVE'
															| translate
													}}
												</label>
												<input
													nbInput
													id="max-goals"
													min="5"
													fullWidth
													formControlName="maxObjectives"
													type="number"
												/>
											</div>
											<div class="col-md-4">
												<label
													class="label"
													for="max-key-result"
												>
													{{
														'GOALS_PAGE.FORM.LABELS.KEY_RESULT'
															| translate
													}}
												</label>
												<input
													nbInput
													id="max-key-result"
													fullWidth
													formControlName="maxKeyResults"
													min="5"
													type="number"
												/>
											</div>
										</div>
									</div>
									<div class="col-md-4">
										<p class="font-weight-bold">
											{{
												'GOALS_PAGE.SETTINGS.EMPLOYEE_OBJECTIVES'
													| translate
											}}
										</p>
										<nb-toggle
											formControlName="employeeCanCreateObjective"
										></nb-toggle>
									</div>
								</div>

								<div class="row mt-3">
									<div class="col-md-4">
										<p class="mt-3 font-weight-bold">
											{{
												'GOALS_PAGE.SETTINGS.WHO_CAN_OWN_OBJECTIVES'
													| translate
											}}
										</p>
										<nb-select
											fullWidth
											(selectedChange)="
												saveGeneralSettings()
											"
											formControlName="canOwnObjectives"
										>
											<nb-option
												*ngFor="
													let level of goalOwnershipEnum
														| keyvalue
												"
												[value]="level.value"
											>
												{{
													'GOALS_PAGE.OWNERSHIP.' +
														level.key | translate
												}}
											</nb-option>
										</nb-select>
									</div>
									<div class="col-md-4">
										<p class="mt-3 font-weight-bold">
											{{
												'GOALS_PAGE.SETTINGS.WHO_CAN_OWN_KEY_RESULTS'
													| translate
											}}
										</p>
										<nb-select
											fullWidth
											(selectedChange)="
												saveGeneralSettings()
											"
											formControlName="canOwnKeyResult"
										>
											<nb-option
												*ngFor="
													let level of goalOwnershipEnum
														| keyvalue
												"
												[value]="level.value"
											>
												{{
													'GOALS_PAGE.OWNERSHIP.' +
														level.key | translate
												}}
											</nb-option>
										</nb-select>
									</div>
								</div>
								<div class="row mt-3">
									<div class="col-md-4">
										<p class="mt-3 font-weight-bold">
											{{
												'GOALS_PAGE.SETTINGS.ADD_KPI_TO_KEY_RESULT'
													| translate
											}}
										</p>
										<nb-toggle
											status="basic"
											formControlName="krTypeKPI"
										></nb-toggle>
									</div>
									<div class="col-md-4">
										<p class="mt-3 font-weight-bold">
											{{
												'GOALS_PAGE.SETTINGS.ADD_TASK_TO_KEY_RESULT'
													| translate
											}}
										</p>
										<nb-toggle
											status="basic"
											formControlName="krTypeTask"
										></nb-toggle>
									</div>
								</div>
							</form>
						</nb-card-body>
						<!--Please do not remove this comment section-->
						<!-- <nb-card-footer>
							<button
								nbButton
								status="success"
								(click)="addTemplate()"
							>
								Add Template
							</button>
						</nb-card-footer> -->
					</nb-card>
				</div>
			</nb-tab>
			<nb-tab
				tabId="timeframe"
				tabTitle="{{
					'GOALS_PAGE.SETTINGS.TIME_FRAME_PAGE_TITLE' | translate
				}}"
			>
				<div class="mb-3">
					<button
						nbButton
						status="success"
						(click)="editTimeFrame('add')"
						class="mr-2"
					>
						<nb-icon class="mr-1" icon="plus-outline"></nb-icon
						>{{ 'BUTTONS.ADD' | translate }}
					</button>
					<ng-container *ngIf="dataLayoutStyle === 'TABLE'">
						<ng-container
							*ngTemplateOutlet="actionButtons"
						></ng-container>
					</ng-container>
				</div>
			</nb-tab>
			<nb-tab
				tabId="kpi"
				tabTitle="{{ 'GOALS_PAGE.SETTINGS.KPI' | translate }}"
			>
				<div class="mb-3">
					<button
						nbButton
						status="success"
						(click)="editKPI('add')"
						class="mr-2"
					>
						<nb-icon class="mr-1" icon="plus-outline"></nb-icon
						>{{ 'BUTTONS.ADD' | translate }}
					</button>
					<ng-container *ngIf="dataLayoutStyle === 'TABLE'">
						<ng-container
							*ngTemplateOutlet="actionButtons"
						></ng-container>
					</ng-container>
				</div>
			</nb-tab>
		</nb-tabset>
		<div
			[nbSpinner]="loading"
			nbSpinnerStatus="primary"
			nbSpinnerSize="large"
		>
			<ng-container *ngIf="selectedTab != 'general'">
				<ng2-smart-table
					[settings]="smartTableSettings"
					[source]="smartTableData"
					(userRowSelect)="selectRow($event)"
					style="cursor: pointer"
					*ngIf="dataLayoutStyle === 'TABLE'"
					#goalSettingsTable
				>
				</ng2-smart-table>
				<ga-card-grid
					[settings]="smartTableSettings"
					[source]="goalTimeFrames"
					*ngIf="dataLayoutStyle === 'CARDS_GRID'"
					[buttonTemplate]="actionButtons"
				></ga-card-grid>
			</ng-container>
		</div>
	</nb-card-body>
</nb-card>
<ng-template
	#actionButtons
	let-buttonSize="buttonSize"
	let-selectedItem="selectedItem"
>
	<button
		*ngIf="selectedTab !== 'kpi'"
		nbButton
		status="info"
		(click)="editTimeFrame('edit', selectedItem)"
		class="mr-2"
		[disabled]="!selectedItem && disableButton"
		[size]="buttonSize || 'medium'"
	>
		<nb-icon class="mr-1" icon="edit-outline"></nb-icon>
		{{ 'BUTTONS.EDIT' | translate }}
	</button>
	<button
		*ngIf="selectedTab !== 'kpi'"
		nbButton
		status="danger"
		(click)="deleteTimeFrame(selectedItem)"
		class="mr-2"
		[disabled]="!selectedItem && disableButton"
		[size]="buttonSize || 'medium'"
	>
		<nb-icon class="mr-1" icon="archive-outline"></nb-icon>
		{{ 'BUTTONS.DELETE' | translate }}
	</button>

	<button
		*ngIf="selectedTab === 'kpi'"
		nbButton
		status="info"
		(click)="editKPI('edit', selectedItem)"
		class="mr-2"
		[disabled]="!selectedItem && disableButton"
		[size]="buttonSize || 'medium'"
	>
		<nb-icon class="mr-1" icon="edit-outline"></nb-icon>
		{{ 'BUTTONS.EDIT' | translate }}
	</button>
	<button
		*ngIf="selectedTab === 'kpi'"
		nbButton
		status="danger"
		(click)="deleteKPI(selectedItem)"
		class="mr-2"
		[disabled]="!selectedItem && disableButton"
		[size]="buttonSize || 'medium'"
	>
		<nb-icon class="mr-1" icon="archive-outline"></nb-icon>
		{{ 'BUTTONS.DELETE' | translate }}
	</button>
</ng-template>
